import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=7f495b1e&scoped=true"
import script from "./Mark.vue?vue&type=script&lang=ts"
export * from "./Mark.vue?vue&type=script&lang=ts"
import style0 from "./Mark.vue?vue&type=style&index=0&id=7f495b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f495b1e",
  null
  
)

export default component.exports